import { RDUsdaAgiThreshold } from '@cibo/core'
import { ResourceDetailFeature } from '@cibo/ui'
import { RDUsdaAgiThresholdTaskEditor } from './RDUsdaAgiThresholdTaskEditor'

export const RDUsdaAgiThresholdResourceDetailFeature: ResourceDetailFeature<RDUsdaAgiThreshold> = {
  traitId: 'usdaAgiThreshold',
  TaskEditor: RDUsdaAgiThresholdTaskEditor,
}
